import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/projectImg.png';
import UTrackerImg from '../images/utracker.jpg';
import GreenCtgImg from '../images/greenctg.jpg';
import PinterestImg from '../images/pinterest.png';
import CavinImg from '../images/cavinimg.jpg';

const projects = [
  {
    id: uuidv4(),
    name: 'CHAT APP',
    desc: 'Real-time chat experience built with React.js, Node.js, Express, and MongoDB, with a responsive interface and API-driven messaging workflows.',
    link: 'https://chatappmini.vercel.app',
    img: UTrackerImg,
  },
  {
    id: uuidv4(),
    name: 'MY PERSONAL WEBSITE',
    desc: 'Responsive personal portfolio website built with semantic HTML, modern CSS, and vanilla JavaScript with a focus on clean presentation and usability.',
    link: 'http://mypersonalminiwebsite.vercel.app/',
    img: GreenCtgImg,
  },
  {
    id: uuidv4(),
    name: 'PINTEREST CLONE',
    desc: 'Pinterest-inspired visual discovery platform built with React.js and Sanity, including content browsing, image-focused layouts, and user interactions.',
    link: 'https://pinterestcloneapp.vercel.app/login',
    img: PinterestImg,
  },
  {
    id: uuidv4(),
    name: "project 4",
    desc: 'An upcoming product concept focused on turning complex workflows into a clear, responsive, and easy-to-use digital experience.',
    link: '',
    img: CavinImg,
  },
  {
    id: uuidv4(),
    name: 'project 5',
    desc: 'An upcoming full stack project exploring reliable APIs, polished frontend experiences, and scalable product architecture.',
    link: '',
    img: ProjectImg,
  },
];

export default projects;
